import React, {PropTypes} from 'react';
import classnames from 'classnames';

const User = ({
                userId,
                username,
                when,
                showText = true,
                limitUserLength = false,
                textPosition = 'right',
              }) => {
  const profileUrl = `/member/${username}`;
  const avatarUrl = `https://d2w4qhtqw2dbsq.cloudfront.net/profile_live/${userId}/large.jpg`;
  const componentClassName = classnames({
    'qa-user': true,
    'qa-user--text-right': showText && textPosition === 'right',
    'qa-user--text-left': showText && textPosition === 'left',
  });
  const imageContainerClassName = classnames({
    'qa-user__avatar': true,
    'qa-user__avatar--right': showText && textPosition === 'left',
    'qa-user__avatar--left': showText && textPosition === 'right',
  });
  const usernameClassName = classnames({
    'qa-user__name': true,
    'qa-user__name--limit-length': limitUserLength,
  });
  return (
    <div className={componentClassName}>
      <div className="qa-user__details">
        <a data-mz="true" className="link link--inherit-color link--emphasis t-user-link" href={profileUrl}>
          { showText && <span className={usernameClassName}>{username}</span> }
          <div className={imageContainerClassName}>
            <img className="avatar__image-inner" src={avatarUrl} alt="Avatar" />
          </div>
        </a>
      </div>
      {when && showText && <div className="qa-user__time">{when}</div>}
    </div>
  );
};

User.propTypes = {
  userId: PropTypes.number,
  username: PropTypes.string,
  when: PropTypes.string,
  showText: PropTypes.bool,
  limitUserLength: PropTypes.bool,
  textPosition: PropTypes.string,
};

export default User;
